import React from 'react'
import PropTypes from 'prop-types'
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight'

function FooterHeader({ title }) {
  return (
    <>
      {/* eslint-disable-next-line */}
    <a className="footer__link" href="JavaScript:Void(0);" tabIndex="0">
        {title.toUpperCase()}
        <FaAngleRight className="mobile arrow-right" />
      </a>
    </>
  )
}

FooterHeader.propTypes = {
  title: PropTypes.string.isRequired
}

export default FooterHeader
